import {
  GET_BOOKMARKS,
  GET_BOOKMARKS_SUCCESS,
  GET_BOOKMARKS_ERROR,
  DELETE_BOOKMARK,
  DELETE_BOOKMARK_SUCCESS,
  DELETE_BOOKMARK_ERROR,
} from "../../constants/action-types";
import { ApiService } from "../../util/ApiService";
import config from "../../util/api-config";
import { showErrorMsg } from ".";

const gateRequester = new ApiService(config.personalizationEdge);

export const getBookmarks = async (dispatch) => {
  try {
    dispatch({ type: GET_BOOKMARKS });
    const { data } = await gateRequester.get(`/bookmarks`);
    dispatch({ type: GET_BOOKMARKS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_BOOKMARKS_ERROR, error: error.message });
  }
};

export const deleteBookmark = async (dispatch, slug, bookmarkIndex) => {
  try {
    dispatch({ type: DELETE_BOOKMARK });
    await gateRequester.delete(`/bookmarks${slug}`);
    dispatch({ type: DELETE_BOOKMARK_SUCCESS, payload: bookmarkIndex });
  } catch (error) {
    dispatch({
      type: DELETE_BOOKMARK_ERROR,
      error: error.message,
    });
    showErrorMsg(dispatch);
  }
};
